import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

import TopicsCard from './topics-card/index.jsx'

const SelectedTopics = ({
  selectedTopic,
  selectedTopics,
  similarTopics,
  // signalTopics,
  recommendedTopics,
  onAddTopic,
  loading,
  translatedTopics,
}) => {
  const handleAddTopic = (topic) => () => onAddTopic(topic)
  const handleAddTopics = ({ items }) => items.forEach((topic) => onAddTopic(topic))
  const hasNoRecommendation = recommendedTopics.length === 0
  const hasNoSimilar = similarTopics.length === 0

  const filterRepeatedTopics = (topicsToFilter) =>
    topicsToFilter.filter(
      (topic) =>
        !selectedTopics.some((selected) =>
          topic._id ? topic._id === selected._id : topic.name === selected.name
        )
    )

  const renderCard = (items, title) => (
    <TopicsCard
      translatedTopics={translatedTopics}
      onAddTopic={handleAddTopic}
      hasNoRecommendation={hasNoRecommendation}
      hasNoSimilar={hasNoSimilar}
      loading={loading}
      selectedTopic={selectedTopic}
      items={items}
      title={title}
      onAddAll={handleAddTopics}
    />
  )

  return renderCard(filterRepeatedTopics(similarTopics), 'Similar Topics')
}

const topicsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    _id: PropTypes.string,
  })
)

SelectedTopics.propTypes = {
  loading: PropTypes.bool,
  selectedTopic: PropTypes.object,
  selectedTopics: topicsPropType,
  similarTopics: topicsPropType,
  recommendedTopics: topicsPropType,
  signalTopics: topicsPropType,
  onAddTopic: PropTypes.func,
}

SelectedTopics.defaultProps = {
  loading: false,
  selectedTopic: '',
  selectedTopics: [],
  similarTopics: [],
  recommendedTopics: [],
  signalTopics: [],
  onAddTopic: () => {},
}

export default SelectedTopics
